import { render, staticRenderFns } from "./tipo-usuario.vue?vue&type=template&id=4b10f12d"
import script from "./tipo-usuario.vue?vue&type=script&lang=js"
export * from "./tipo-usuario.vue?vue&type=script&lang=js"
import style0 from "./tipo-usuario.vue?vue&type=style&index=0&id=4b10f12d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports